import { gql } from 'graphql-tag';

const frameFragment = gql`
  fragment FrameDetail on DigitalFrame {
    id
    title
    frame_delay
    frame_order
    objects
    preview_image_url
    from_layout
    is_visited
    play_in_ids
    play_out_ids
  }
`;

export const digitalSheetFragment = gql`
  fragment SheetInfo on Sheet {
    id
    digital_frames {
      ...FrameDetail
    }
    digital_transitions {
      id
      duration
      direction
      transition_order
      transition_type
    }
  }
  ${frameFragment}
`;

export const getSheetFramesQuery = gql`
  query getSheetFrames($sheetId: ID!) {
    sheet(id: $sheetId) {
      ...SheetInfo
    }
  }
  ${digitalSheetFragment}
`;

export const getFrameObjectQuery = gql`
  query getFrameObject($frameId: ID!) {
    digital_frame(id: $frameId) {
      id
      objects
    }
  }
`;
